module.exports = __webpack_public_path__ + "img/nocontent.2c6f8c7c.svg";